import { envConfig } from '@/config/env'

const referralModalSharedUiClassNames = {
  overlay: 'fixed inset-0 z-[1520] flex items-end justify-center bg-black/70 px-0 pb-0 pt-[30px]',
  header: 'sticky top-0 z-20 w-full',
  headerFade: 'pointer-events-none absolute inset-x-0 top-0 h-[92px] bg-[linear-gradient(180deg,rgba(28,28,30,0.34)_0%,rgba(28,28,30,0.2)_30%,rgba(28,28,30,0.1)_58%,rgba(28,28,30,0.04)_78%,rgba(28,28,30,0)_100%)] transition-opacity duration-300',
  headerFadeVisible: 'opacity-100 backdrop-blur-[2px] [mask-image:linear-gradient(to_bottom,black_0%,black_62%,transparent_100%)] [-webkit-mask-image:linear-gradient(to_bottom,black_0%,black_62%,transparent_100%)]',
  headerFadeHidden: 'opacity-0',
  headerContent: 'relative z-10 flex h-[68px] w-full items-start justify-end px-4 pt-[30px]',
}

export const appConfig = {
  routes: {
    root: '/',
    subscriptions: '/subscriptions',
    balance: '/balance',
    balanceHistory: '/balance/history',
    balanceHistoryExpenses: '/balance/history/expenses',
    balanceHistoryIncomes: '/balance/history/incomes',
    balanceTopupPaymentForm: '/balance/topup/payment-form',
    homeTrialActivationPaymentForm: '/trial/activate/payment-form',
    referrals: '/referrals',
    referralsTotalEarnings: '/referrals/total-earnings',
    referralsCommission: '/referrals/commission',
    referralsList: '/referrals/list',
    referralsListItemPattern: '/referrals/list/:referralTelegramId',
    profile: '/profile',
    configs: '/configs',
    subscriptionDetailsPrefix: '/subscription',
    subscriptionDetailsPattern: '/subscription/:subscriptionId',
    subscriptionAutopaymentPattern: '/subscription/:subscriptionId/autopayment',
    subscriptionDevicesPattern: '/subscription/:subscriptionId/devices',
    subscriptionQrPattern: '/subscription/:subscriptionId/qr',
    installGuide: '/install-guide',
    happRedirect: '/happ-redirect',
    payHandoff: '/pay-handoff',
    payment: '/payment',
    dashboard: '/dashboard',
    support: '/support',
    admin: '/admin',
    planPrefix: '/plan',
    planPattern: '/plan/:packageId',
    legalPrefix: '/legal',
    legalPattern: '/legal/:type',
    legalPages: {
      privacyPolicy: 'privacy-policy',
      publicOffer: 'public-offer',
      returnPolicy: 'return-policy',
    },
  },
  cache: {
    defaultDurationMs: 5 * 60 * 1000,
  },
  api: {
    baseUrl: envConfig.apiBaseUrl,
    requestTimeoutMs: 10000,
    unauthorizedStatusCode: 401,
    notFoundStatusCode: 404,
  },
  publicAppBaseUrl: envConfig.publicAppBaseUrl,
  authPortalBaseUrl: envConfig.authPortalBaseUrl,
  auth: {
    adminUsername: 'admin',
    profileNotFoundErrorCode: 'user not found',
    pendingPaymentCheckDelayMs: 2000,
    pendingPaymentTtlMs: 60 * 60 * 1000,
  },
  telegram: {
    fullscreenMinVersion: '8.0',
  },
  storageKeys: {
    token: 'vpnToken',
    user: 'vpnUser',
    pendingPaymentMarker: 'stride_pending_payment',
    pendingPaymentId: 'stride_pending_payment_id',
    pendingPaymentTimestamp: 'stride_pending_payment_ts',
    balanceDisplaySettings: 'stride_balance_display_settings',
    balanceSpoilerBalanceRevealed: 'stride_balance_spoiler_balance_revealed',
    balanceSpoilerHistoryRevealed: 'stride_balance_spoiler_history_revealed',
  },
  externalLinks: {
    telegramChannelUrl: 'https://t.me/astride_vpn',
    telegramCommunityUrl: '',
    supportBotUrl: 'https://t.me/astride_supportbot',
    userAgreementUrl: 'https://telegra.ph/Polzovatelskoe-soglashenie-StrideVPN-03-10',
    privacyPolicyUrl: 'https://telegra.ph/Politika-konfidencialnosti-StrideVPN-03-10',
    installGuide: {
      appleTv: {
        appStoreRu: '',
        appStoreGlobal: '',
        instructionsRu: '',
        instructionsEn: '',
      },
    },
  },
  support: {
    contactEmail: 'support@empalar.com',
  },
  locale: {
    dateLocale: 'ru-RU',
    numberLocale: 'ru-RU',
  },
  admin: {
    version: '1.0.0',
    uiClassNames: {
      actionButtonBase: 'w-full rounded-xl px-4 py-2.5 text-sm font-semibold transition-opacity',
      actionButtonPrimary: 'bg-tg-button text-tg-button-text hover:opacity-90',
      actionButtonDanger: 'border border-red-200 bg-red-50 text-red-600 hover:opacity-90',
      panelSurface: 'rounded-2xl border border-black/5 bg-tg-bg p-4 shadow-sm',
      statsCardSurface: 'rounded-2xl border border-black/5 bg-tg-bg p-4 shadow-sm',
      statsCardSuccessSurface: 'rounded-2xl border border-green-200 bg-green-50 p-4 shadow-sm',
      statsCardErrorSurface: 'rounded-2xl border border-red-200 bg-red-50 p-4 shadow-sm',
      balancePanelSurface: 'rounded-2xl border-2 border-blue-300 bg-blue-50 p-4 shadow-sm',
      balancePanelTitle: 'mb-4 text-lg font-semibold text-blue-800',
      balanceFieldLabel: 'mb-2 block text-sm font-medium text-blue-700',
      balanceInput: 'w-full rounded-lg border border-blue-200 bg-white px-3 py-2 text-sm text-gray-800 focus:border-blue-400 focus:outline-none',
      balanceInputFlex: 'flex-1 rounded-lg border border-blue-200 bg-white px-3 py-2 text-sm text-gray-800 focus:border-blue-400 focus:outline-none',
      balanceSearchButton: 'rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700',
      balanceSelectedUserSurface: 'mb-4 rounded-lg border border-blue-200 bg-white p-3',
      balanceSelectedUserText: 'text-sm font-medium text-gray-700',
      balanceSelectedMetaText: 'text-sm text-gray-600',
      balanceSelectedAmountText: 'mt-2 text-lg font-bold text-blue-700',
      balanceActionPrimary: 'flex-1 rounded-lg bg-green-600 px-4 py-2.5 text-sm font-semibold text-white hover:bg-green-700 disabled:opacity-50',
      balanceActionDanger: 'flex-1 rounded-lg bg-red-600 px-4 py-2.5 text-sm font-semibold text-white hover:bg-red-700 disabled:opacity-50',
    },
  },
  subscriptions: {
    maxDevices: 6,
    defaultAdditionalDeviceMarkupRub: 90,
    skeletonRowsCount: 1,
    refreshMinSpinnerMs: 3000,
    layout: {
      landingDefaultBottomViewportGapPx: 70,
      landingListBottomViewportGapPx: 90,
    },
    statusColorClassNames: {
      active: 'text-[#0F7]',
      expired: 'text-[#FF005A]',
      activation: 'text-[#EAB308]',
    },
    uiClassNames: {
      rootPadding: 'px-8 pb-8',
      rootTopPadding: 'pt-[10px]',
      profileRootGap: 'gap-[33px]',
      emptyRootGap: 'gap-[25px]',
      landingRootContainer: 'flex min-h-screen min-w-screen flex-col items-center gap-2.5 overflow-hidden bg-[#000] px-5 pt-[115px]',
      landingSectionContainer: 'flex w-full flex-col items-center gap-[15px]',
      landingTitleRow: 'flex w-full flex-col items-start justify-center gap-2.5',
      landingTitleText: 'w-fit font-inter text-[21px] font-bold text-[#FFF]',
      landingListWrapper: 'flex w-full flex-col items-center',
      landingListSurface: 'flex w-full flex-col items-start gap-2.5 overflow-hidden rounded-b-none rounded-t-[25px] bg-[#1C1C1E] pb-2.5 pl-[15px] pr-0 pt-2.5',
      landingRowsContainer: 'flex w-full flex-col items-start gap-1.5',
      landingRowButton: 'flex w-full cursor-pointer items-center justify-center gap-2.5 pb-2.5 pl-0 pr-[15px] pt-2.5 transition-transform active:scale-[0.98]',
      landingDivider: 'h-px w-full bg-[#404040]',
      landingFooterSurface: 'flex w-full flex-col items-center justify-center gap-2.5 overflow-hidden rounded-b-[25px] rounded-t-none bg-[#1C1C1E] pb-[15px] pl-[15px] pr-[15px] pt-0',
      landingActionWrap: 'flex h-12 w-full items-center justify-center gap-2.5 overflow-hidden rounded-[100px] bg-[#27272A] px-[15px] py-2.5',
      landingActionButton: 'flex w-full cursor-pointer items-center justify-center gap-2.5 text-nowrap',
      landingActionText: 'w-fit font-inter text-base font-medium text-[#0091FF]',
      landingEmptyCard: 'flex w-full flex-col items-center gap-2.5 overflow-hidden rounded-[25px] bg-[#1C1C1E] px-5 py-[25px]',
      landingEmptyContent: 'flex w-full flex-col items-start gap-5',
      landingEmptyDescription: 'w-full text-center font-inter text-sm text-[#ADADB4]',
      landingTrialRootContainer: 'flex min-h-screen min-w-screen flex-col items-center gap-2.5 overflow-hidden bg-[#000] px-5 pb-[90px] pt-[115px]',
      landingTrialContentContainer: 'flex w-full flex-col items-start gap-[15px]',
      landingTrialTitleContainer: 'flex w-full flex-col items-center gap-2.5',
      landingTrialTitleText: 'w-full text-center font-inter text-[22px] font-semibold text-[#FFF]',
      landingTrialCtaContainer: 'flex w-full flex-col items-center gap-[15px]',
      landingTrialCtaButton: 'cursor-pointer text-nowrap flex w-fit items-center justify-center gap-2.5 overflow-hidden rounded-[100px] bg-[#007CFF] px-10 py-3.5 transition-transform active:scale-[0.99]',
      landingTrialCtaButtonText: 'w-fit font-inter text-[17px] font-semibold text-[#FFF]',
      landingTrialHintText: 'w-full text-center font-inter text-[13px] text-[#ADADB4]',
      headerGap: 'gap-[22px]',
      listGap: 'gap-2.5',
      headerRowPadding: 'px-2',
      refreshGap: 'gap-1.5',
      refreshTextSize: 'text-[15px]',
      rowsGap: 'gap-[5px]',
      rowPadding: 'py-[9px] px-[22px]',
      rowRounded: 'rounded-[25px]',
      skeletonLeftWidth: 'w-[183px]',
      skeletonRightWidth: 'w-[134px]',
      untilTextSize: 'text-[15px]',
      statusTextSize: 'text-[13px]',
      maxNameWidth: 'max-w-[180px]',
      subscriptionValueTextSize: 'text-[17px]',
      listHeaderMaxWidth: 'max-w-[329px]',
      landingStatusActiveText: 'text-[#0091FF]',
      landingStatusInactiveText: 'text-[#ADADB4]',
    },
  },
  transactions: {
    pageSize: 10,
    scrollFetchThresholdPx: 100,
    amountColorClassNames: {
      positive: 'text-[#0F7]',
      negative: 'text-[#007CFF]',
    },
    uiClassNames: {
      surfaceBackground: 'bg-[#333]',
      textPrimary: 'text-[#FFF]',
      textSecondary: 'text-[#B3B3B3]',
      primaryActionBackground: 'bg-[#0AF]',
      surfaceRounded: 'rounded-[20px]',
      compactGap: 'gap-2.5',
      sectionGap: 'gap-[33px]',
      headerGap: 'gap-[22px]',
      listGap: 'gap-[15px]',
      actionsGap: 'gap-3.5',
      surfaceWidth: 'w-[329px]',
      actionsWidth: 'w-[330px]',
      balanceCardPadding: 'py-10 px-0',
      rowPadding: 'py-2.5 px-2.5',
      rowContentWidth: 'w-[310px]',
      rowInnerWidth: 'w-[249px]',
      rowContentPaddingRight: 'pr-[3px]',
      rowContentHeight: 'h-12',
      transactionIconSize: 'w-10 h-10',
      subtitleTextSize: 'text-[15px]',
      balanceValueTextSize: 'text-[40px]',
      skeletonRoundSize: 'w-12 h-12',
      skeletonTitleSize: 'w-24 h-4',
      skeletonDetailSize: 'w-16 h-3',
      skeletonAmountSize: 'w-20 h-4',
      loadingHeaderTitleSize: 'w-48 h-6',
      loadingHeaderValueSize: 'w-32 h-12',
      loadingSectionTitleSize: 'w-24 h-6',
      emptyStateTopMargin: 'mt-[30px]',
      scrollContainerTopPadding: 'pt-[10px]',
    },
  },
  balancePage: {
    transactionsFetchLimit: 50,
    historyPreviewCount: 3,
    topup: {
      minAmountRub: 1,
      maxAmountRub: 1000000,
      presetAmountsRub: [100, 300, 500, 1000],
      defaultPresetAmountRub: 100,
      maxInputLength: 10,
      modalTopInsetPx: 24,
    },
    summary: {
      defaultBonusPoints: 0,
    },
    settings: {
      defaults: {
        hideBalanceOnEntry: false,
        hideHistoryPreviewOnEntry: false,
        showExpensesOnMainScreen: true,
        showAllExpensesOnMainScreen: true,
        showPurchasesOnMainScreen: true,
        showGiftsInHistoryPreview: false,
      },
    },
    uiClassNames: {
      rootContainer: 'flex min-h-screen min-w-screen flex-col items-center gap-2.5 overflow-hidden bg-[#000] px-5 pb-[90px] pt-[115px]',
      contentContainer: 'flex w-full max-w-[361px] flex-col items-center gap-10',
      topSectionContainer: 'flex w-full flex-col items-center gap-[50px]',
      balanceHeaderContainer: 'flex w-[89px] flex-col items-center gap-[5px]',
      balanceValueRow: 'flex w-full items-center justify-center gap-[5px]',
      balanceValueText: 'font-inter w-fit text-[32px] font-bold text-[#FFF]',
      balanceCurrencyText: 'font-inter w-fit text-[32px] font-bold text-[#ADADAD]',
      bonusPillContainer: 'flex w-fit items-center justify-center gap-[5px] overflow-hidden rounded-[100px] bg-[#161C25] px-2.5 py-[5px]',
      bonusValueText: 'font-inter w-fit text-sm font-medium text-[#007CFF]',
      actionsRowContainer: 'flex w-full items-center justify-center gap-[5px]',
      actionButton: 'flex w-full flex-col items-center justify-center gap-2.5 overflow-hidden rounded-[25px] bg-[#161C25] px-0 py-[15px] transition-opacity hover:opacity-90 active:opacity-80 disabled:opacity-60',
      actionButtonText: 'font-inter w-fit text-[15px] font-medium text-[#007CFF]',
      sectionContainer: 'flex w-full flex-col items-start gap-[15px]',
      sectionHeaderButton: 'flex w-fit items-center gap-[5px] transition-opacity hover:opacity-90 active:opacity-80',
      sectionTitleText: 'font-inter w-fit text-[21px] font-bold text-[#FFF]',
      historyListContainer: 'flex w-full flex-col items-start gap-2.5 overflow-hidden rounded-[25px] bg-[#2B2B2C] pl-[15px] pr-0 py-[5px]',
      historyRow: 'flex w-full items-center justify-center gap-2.5 rounded-[20px] pb-2.5 pr-[15px] pt-2.5 pl-0',
      historyLeftColumn: 'flex w-fit items-center gap-2.5',
      historyIconWrap: 'flex h-12 w-12 items-center justify-center overflow-hidden rounded-[100px] bg-[#2D2D2D] p-[9px]',
      historyTextColumn: 'flex w-fit flex-col items-start justify-center',
      historyTitleText: 'font-inter w-fit text-base font-medium text-[#FFF]',
      historySubtitleText: 'font-inter w-fit text-[15px] font-medium text-[#ADADAD]',
      historyAmountColumn: 'flex w-fit flex-col items-end justify-center',
      historyAmountText: 'font-inter w-full text-right text-base font-medium',
      historyDateText: 'font-inter w-full text-right text-[15px] font-medium text-[#ADADAD]',
      historyDivider: 'h-px w-full bg-[#404040]',
      monthlyCardsRow: 'flex -mx-5 w-[calc(100%+40px)] overflow-x-auto pb-1 [scrollbar-width:none] [-ms-overflow-style:none]',
      monthlyCardsTrack: 'flex w-max items-stretch gap-2.5 pl-5 pr-0',
      monthlyCard: 'flex w-[129px] shrink-0 flex-col items-start gap-2.5 overflow-hidden rounded-[25px] bg-[#2B2B2C] p-[15px]',
      monthlyCardContent: 'flex w-full flex-col items-start gap-10',
      monthlyValueText: 'font-inter w-fit text-[19px] font-bold text-[#FFF]',
      monthlyLabelText: 'font-inter w-fit text-[15px] font-medium text-[#ADADAD]',
      emptyStateCard: 'flex w-full items-center justify-center rounded-[25px] bg-[#2B2B2C] px-4 py-6',
      emptyStateText: 'font-inter text-center text-sm text-[#ADADAD]',
      chevronIcon: 'h-[13px] w-2',
      actionIconBase: 'h-6 w-6',
      bonusIcon: 'h-3.5 w-3.5',
      historyIcon: 'h-[30px] w-[30px]',
      monthlyIconSquare: 'h-8 w-8',
      monthlyIconRect: 'h-[30px] w-8',
      hiddenSensitiveButton: 'relative inline-flex items-center justify-center overflow-hidden rounded-[12px]',
      hiddenSensitiveGhostRow: 'flex items-center justify-center gap-[5px] opacity-0',
      hiddenHistoryCard: 'relative w-full overflow-hidden rounded-[25px]',
      hiddenHistoryGhostContent: 'opacity-0',
      settingsModalContainer: 'flex max-h-[calc(100dvh-16px)] w-full flex-col items-center overflow-hidden rounded-[34px] bg-[#1C1C1E] px-4 py-4',
      settingsModalContent: 'flex h-full min-h-0 w-full flex-col items-center gap-3',
      settingsModalCloseRow: 'sticky top-0 z-10 flex w-full items-center justify-end bg-[#1C1C1E] pb-1',
      settingsModalSectionsWrap: 'flex min-h-0 w-full flex-col items-center gap-6 overflow-y-auto px-1 pb-1',
      settingsModalSection: 'flex w-full flex-col items-start gap-3',
      settingsModalSectionTitleButton: 'cursor-default text-nowrap flex w-fit flex-col items-center justify-center gap-2.5',
      settingsModalSectionTitleText: 'font-inter w-fit text-[17px] font-medium text-[#ADADB4]',
      settingsModalSectionBody: 'flex w-full flex-col items-start gap-4',
      settingsModalRow: 'flex w-full items-center justify-between',
      settingsModalRowLabel: 'font-inter text-[17px] font-medium text-[#FFF]',
      settingsModalRowLabelWide: 'w-[265px]',
      settingsModalToggleBase: 'relative flex h-[31px] w-[51px] items-center overflow-hidden rounded-[100px] p-0.5 transition-colors duration-200 ease-out',
      settingsModalToggleOn: 'bg-[#34C759]',
      settingsModalToggleOff: 'bg-[rgba(120,120,128,0.16)]',
      settingsModalToggleDisabled: 'cursor-not-allowed opacity-50',
      settingsModalToggleThumb: 'h-[27px] w-[27px] rounded-[100px] bg-[#FFF] shadow-[0_0_1px_rgba(0,0,0,0.04),0_3px_8px_0_rgba(0,0,0,0.15),0_3px_1px_0_rgba(0,0,0,0.06)] transition-transform duration-200 ease-out',
      settingsModalToggleThumbOn: 'translate-x-5',
      settingsModalToggleThumbOff: 'translate-x-0',
      settingsModalRowDisabled: 'opacity-60',
      settingsModalExpenseRowLeft: 'flex w-fit items-center gap-2.5',
      settingsModalExpenseIconWrap: 'flex h-12 w-12 items-center justify-center overflow-hidden rounded-[100px] bg-[#2D2D2D] p-[9px]',
      settingsModalExpenseLabel: 'font-inter w-fit text-[17px] font-medium text-[#FFF]',
      settingsModalSupportButton: 'cursor-pointer text-nowrap flex w-full items-center justify-center gap-2.5 overflow-hidden rounded-[100px] bg-[#2C2C2E] px-[15px] py-3.5 transition-transform active:scale-[0.99] disabled:cursor-not-allowed disabled:opacity-60',
      settingsModalSupportButtonText: 'font-inter w-fit text-[17px] font-medium text-[#007CFF]',
      topupModalOverlay: 'fixed inset-0 z-[1400] flex items-end justify-center bg-black/70 px-0 pb-0 pt-6',
      topupModalContainer: 'flex w-full flex-col items-center gap-2.5 overflow-y-auto rounded-[40px] bg-[#1C1C1E] px-4 pb-[50px] pt-[30px] shadow-[0_20px_48px_rgba(0,0,0,0.45)]',
      topupModalContent: 'flex w-full flex-col items-end gap-[15px]',
      topupModalHeader: 'flex h-[38px] w-full items-center justify-between',
      topupModalTitle: 'font-inter w-fit text-[21px] font-bold text-[#FFF]',
      topupModalBody: 'flex w-full flex-col items-start gap-[50px]',
      topupModalDescription: 'font-inter w-full text-center text-base font-medium text-[#FFF]',
      topupModalMainSection: 'flex w-full flex-col items-center gap-[25px]',
      topupModalAmountSection: 'flex w-full flex-col items-start gap-[25px]',
      topupModalAmountRow: 'flex w-full items-center justify-between overflow-hidden rounded-[100px] bg-[#2C2C2E] px-5 py-[15px]',
      topupModalAmountLabel: 'font-inter w-fit text-[17px] font-medium text-[#FFF]',
      topupModalAmountControl: 'flex w-fit items-center gap-1 text-[#ADADB4]',
      topupModalAmountInput: 'font-inter w-[112px] bg-transparent text-right text-[17px] font-medium text-[#ADADB4] outline-none placeholder:text-[#ADADB4]',
      topupModalCurrency: 'font-inter text-[17px] font-medium text-[#ADADB4]',
      topupModalPresetGrid: 'flex w-full flex-col items-center gap-2.5',
      topupModalPresetRow: 'flex w-full items-center gap-[15px]',
      topupModalPresetButton: 'flex w-full items-center justify-center overflow-hidden rounded-[100px] border-2 border-transparent bg-[#2C2C2E] px-0 py-2.5 transition-opacity hover:opacity-90 active:opacity-80',
      topupModalPresetButtonActive: 'border-2 border-[#007CFF]',
      topupModalPresetButtonText: 'font-inter w-fit text-[17px] font-medium text-[#FFF]',
      topupModalActions: 'flex w-full flex-col items-center gap-[25px]',
      topupModalPrimaryButton: 'flex h-[47px] w-full items-center justify-center overflow-hidden rounded-[100px] bg-[#007CFF] p-[15px] transition-opacity hover:opacity-90 active:opacity-80 disabled:opacity-60',
      topupModalPrimaryButtonText: 'font-inter w-fit text-base font-medium text-[#FFF]',
      topupModalTermsButton: 'flex w-full items-center justify-center',
      topupModalTermsText: 'font-inter w-[300px] text-center text-base font-medium text-[#007CFF]',
      topupPaymentOverlay: 'fixed inset-0 z-[1450] flex items-end justify-center bg-black/70 px-0 pb-0 pt-6',
      topupPaymentSheetContainer: 'flex max-h-[calc(100dvh-24px)] w-full flex-col items-center overflow-y-auto rounded-[48px] bg-[#1C1C1E] pb-[25px] pt-5',
      topupPaymentHeaderRow: 'flex w-full items-center justify-between px-5 pb-4 pt-2',
      topupPaymentWordmarkIcon: 'w-fit',
      topupPaymentMethodsSection: 'flex w-full flex-col items-start gap-2 px-5 pb-6',
      topupPaymentMethodCard: 'flex w-full items-center justify-center gap-[15px] rounded-3xl bg-[#2C2C2E] p-4',
      topupPaymentMethodLogo: 'h-[17px] w-[15px]',
      topupPaymentMethodTextWrap: 'flex w-full items-start gap-2.5',
      topupPaymentMethodText: 'font-inter w-fit text-[17px] leading-[18px] text-[#FFF]',
      topupPaymentChangeMethodButton: 'flex w-full items-center justify-between gap-[15px] rounded-3xl bg-[#2C2C2E] px-4 py-[18px] transition-opacity hover:opacity-90 active:opacity-80 disabled:opacity-60',
      topupPaymentChangeMethodTextWrap: 'flex w-full flex-col items-start gap-2.5',
      topupPaymentChangeMethodText: 'font-inter w-full text-left text-[17px] leading-[18px] text-[#FFF]',
      topupPaymentChangeMethodChevron: 'h-3 w-2 shrink-0',
      topupPaymentChangeMethodSelect: 'absolute inset-0 h-full w-full cursor-pointer opacity-0 disabled:cursor-not-allowed',
      topupPaymentSummarySection: 'flex w-full flex-col items-center gap-5 px-[30px]',
      topupPaymentSummaryRow: 'flex w-full items-center gap-3.5',
      topupPaymentSummaryTextBlock: 'flex w-full flex-col items-start gap-3.5 pb-2',
      topupPaymentMerchantText: 'font-inter w-full text-base leading-[18px] tracking-[-0.02em] text-[#ADADB4]',
      topupPaymentAmountRow: 'flex w-full items-start gap-2',
      topupPaymentAmountValue: 'font-inter w-fit text-[32px] font-medium leading-[44px] text-[#FFF]',
      topupPaymentAmountCurrency: 'font-inter w-fit text-[32px] font-medium leading-[44px] text-[#FFF]',
      topupPaymentActionSection: 'flex w-full flex-col items-center gap-3.5',
      topupPaymentPayButton: 'flex w-full items-center justify-center gap-2.5 overflow-hidden rounded-[100px] bg-[#007CFF] px-10 py-3.5 transition-opacity hover:opacity-90 active:opacity-80 disabled:opacity-60',
      topupPaymentPayButtonText: 'font-inter w-fit text-[17px] font-semibold text-[#FFF]',
    },
  },
  balanceHistoryPage: {
    transactionsFetchLimit: 100,
    monthFilter: {
      maxMonths: 12,
    },
    search: {
      maxQueryLength: 64,
    },
    defaultFilters: {
      hideGifts: true,
    },
    uiClassNames: {
      rootContainer: 'flex min-h-screen min-w-screen flex-col items-center gap-2.5 overflow-hidden bg-[#000] px-5 pb-[90px] pt-[115px]',
      contentContainer: 'flex w-full max-w-[361px] flex-col items-center gap-[30px]',
      summaryContainer: 'flex w-full flex-col items-start gap-5',
      searchContainer: 'flex w-full items-center gap-2.5 rounded-[100px] bg-[#151515] px-[15px] py-2.5',
      searchInput: 'font-inter w-full bg-transparent text-base font-medium text-[#FFF] placeholder:text-[#565656] outline-none',
      filtersRow: 'flex w-full items-center gap-2.5',
      filterChip: 'relative flex w-fit items-center justify-center gap-2.5 rounded-[100px] bg-[#161C25] px-[15px] py-[5px]',
      filterChipText: 'font-inter w-fit text-base font-medium text-[#007CFF]',
      filterChipSelect: 'absolute inset-0 cursor-pointer opacity-0',
      sectionContainer: 'flex w-full flex-col items-start gap-5',
      sectionTitleRow: 'flex w-full items-center justify-between',
      sectionTitleText: 'font-inter w-fit text-[21px] font-bold text-[#FFF]',
      sectionTotalText: 'font-inter w-fit text-base font-medium text-[rgba(173,173,173,0.50)]',
      statsRow: 'flex w-full items-center gap-[21px]',
      statsCard: 'flex w-full flex-col items-start gap-2.5 rounded-[25px] bg-[#151515] px-[15px] py-5',
      statsCardContent: 'flex w-full flex-col items-start gap-[15px]',
      statsValueText: 'font-inter w-fit text-[19px] font-bold text-[#FFF]',
      statsLabelText: 'font-inter w-fit text-[15px] font-medium text-[#ADADAD]',
      expensesBarTrack: 'relative h-[7px] w-full overflow-hidden rounded-[100px] bg-[#1C2A3A]',
      expensesBarSegmentPurchase: 'absolute inset-y-0 left-0 rounded-[100px] bg-[#007CFF]',
      expensesBarSegmentGift: 'absolute inset-y-0 right-0 bg-[#F7782F]',
      expensesBarSegmentOther: 'absolute inset-y-0 right-0 bg-[#2FDCF7]',
      incomesBarTrack: 'h-[7px] w-full overflow-hidden rounded-[100px] bg-[#1C2A3A]',
      incomesBarFill: 'h-full rounded-[100px] bg-[#007CFF]',
      daySection: 'flex w-full flex-col items-start gap-[15px]',
      historyRow: 'flex w-full items-center justify-between rounded-[20px] px-0 py-2.5',
      historyLeftColumn: 'flex w-fit items-center gap-2.5',
      historyIconWrap: 'flex h-12 w-12 items-center justify-center overflow-hidden rounded-[100px] bg-[#2D2D2D] p-[9px]',
      historyTextColumn: 'flex w-fit flex-col justify-center items-start',
      historyTitleText: 'font-inter w-fit text-base font-medium text-[#FFF]',
      historySubtitleText: 'font-inter w-fit text-[15px] font-medium text-[#ADADAD]',
      historyAmountColumn: 'flex w-fit flex-col justify-center items-end',
      historyAmountText: 'font-inter w-full text-right text-base font-medium',
      historyAmountPositive: 'text-[#0F7]',
      historyAmountNegative: 'text-[#007CFF]',
      historyPartyText: 'font-inter w-full text-right text-[15px] font-medium text-[#ADADAD]',
      historyDivider: 'h-px w-full bg-[#404040]',
      emptyStateCard: 'flex w-full items-center justify-center rounded-[25px] bg-[#2B2B2C] px-4 py-6',
      emptyStateText: 'font-inter text-center text-sm text-[#ADADAD]',
      searchIcon: 'h-5 w-5',
      filterChevronIcon: 'h-[5px] w-2.5',
      filterClearIcon: 'h-2.5 w-2.5',
      historyIcon: 'h-[30px] w-[30px]',
      monthlyIconSquare: 'h-8 w-8 shrink-0',
      monthlyIconRect: 'h-7 w-8 shrink-0',
    },
  },
  balanceExpensesPage: {
    transactionsFetchLimit: 100,
    chart: {
      sizePx: 150,
      heightPx: 173,
      centerX: 75,
      centerY: 95,
      ringRadius: 62,
      ringStrokeWidth: 26,
      badgeDiameterPx: 22,
      labelOffsetPx: 20,
      singleSegmentAnchorAngleDeg: -90,
      colors: {
        track: '#1F1F1F',
        purchase: '#666666',
        gift: '#F2C14F',
      },
    },
    search: {
      maxQueryLength: 64,
    },
    periods: {
      defaultPeriod: 'week' as const,
      weekDays: 7,
    },
    uiClassNames: {
      rootContainer: 'flex min-h-screen min-w-screen flex-col items-center gap-2.5 overflow-hidden bg-[#000] px-5 pb-[90px] pt-[115px]',
      contentContainer: 'flex w-full max-w-[361px] flex-col items-center gap-5',
      topSection: 'flex w-full flex-col items-start gap-5',
      searchContainer: 'flex w-full items-center gap-2.5 rounded-[100px] bg-[#151515] px-[15px] py-2.5',
      searchInput: 'font-inter w-full bg-transparent text-base font-medium text-[#FFF] placeholder:text-[#565656] outline-none',
      toolbarRow: 'flex w-full items-center gap-2.5',
      toolbarIconButton: 'flex items-center justify-center rounded-[100px] bg-[#151515] px-[15px] py-[5px] transition-opacity hover:opacity-90 active:opacity-80',
      toolbarChipActive: 'cursor-default flex items-center gap-2.5 rounded-[100px] bg-[#161C25] px-[15px] py-[5px]',
      toolbarChipInactive: 'cursor-pointer flex items-center gap-2.5 rounded-[100px] bg-[#151515] px-[15px] py-[5px] transition-opacity hover:opacity-90 active:opacity-80',
      toolbarChipActiveText: 'font-inter text-base font-medium text-[#007CFF]',
      toolbarChipInactiveText: 'font-inter text-base font-medium text-[#FFF]',
      summarySection: 'flex w-full flex-col items-start gap-[30px]',
      summaryHeader: 'flex w-full flex-col items-start gap-1.5',
      summaryValueText: 'font-inter text-[26px] font-bold text-[#FFF]',
      summaryLabelText: 'font-inter text-[17px] font-medium text-[#ADADAD]',
      chartWrap: 'flex w-full items-center justify-center',
      periodSection: 'flex w-full flex-col items-start gap-5',
      periodTabsWrap: 'flex w-fit items-center rounded-[100px] bg-[#151515] p-1',
      periodTabBase: 'cursor-pointer rounded-[100px] px-[15px] py-[5px] text-base font-medium transition-opacity hover:opacity-90 active:opacity-80',
      periodTabActive: 'bg-[#2D2D2D] text-[#FFF]',
      periodTabInactive: 'bg-[#151515] text-[#FFF]',
      categoriesList: 'grid w-full grid-cols-2 gap-x-5 gap-y-[15px]',
      categoriesRow: 'flex min-w-0 items-center justify-start gap-[5px]',
      categoriesLeft: 'flex items-center gap-[5px]',
      categoriesIconBadge: 'flex h-6 w-6 items-center justify-center rounded-[100px]',
      categoriesTitleText: 'font-inter text-[15px] font-medium text-[#ADADAD]',
      categoriesAmountText: 'font-inter text-[15px] font-medium text-[#ADADAD]',
      historyListSection: 'flex w-full flex-col items-start gap-5',
      historyDaySection: 'flex w-full flex-col items-start gap-[15px]',
      historyDayHeader: 'flex w-full items-center justify-between',
      historyDayTitle: 'font-inter text-[21px] font-bold text-[#FFF]',
      historyDayTotal: 'font-inter text-base font-medium text-[rgba(173,173,173,0.50)]',
      historyRow: 'flex w-full items-center justify-between rounded-[20px] px-0 py-2.5',
      historyLeftColumn: 'flex w-fit items-center gap-2.5',
      historyIconWrap: 'flex h-12 w-12 items-center justify-center overflow-hidden rounded-[100px] bg-[#2D2D2D] p-[9px]',
      historyTextColumn: 'flex w-fit flex-col items-start justify-center',
      historyTitleText: 'font-inter w-fit text-base font-medium text-[#FFF]',
      historySubtitleText: 'font-inter w-fit text-[15px] font-medium text-[#ADADAD]',
      historyAmountColumn: 'flex w-fit flex-col items-end justify-center',
      historyAmountText: 'font-inter w-full text-right text-base font-medium text-[#007CFF]',
      historyPartyText: 'font-inter w-full text-right text-[15px] font-medium text-[#ADADAD]',
      emptyStateCard: 'flex w-full items-center justify-center rounded-[25px] bg-[#2B2B2C] px-4 py-6',
      emptyStateText: 'font-inter text-center text-sm text-[#ADADAD]',
      searchIcon: 'h-5 w-5',
      toolbarIcon: 'h-5 w-[21px]',
      filterClearIcon: 'h-2.5 w-2.5',
      historyIcon: 'h-[30px] w-[30px]',
      categoryPurchaseBadge: 'bg-[#666666]',
      categoryGiftBadge: 'bg-[#F2C14F]',
    },
  },
  balanceIncomesPage: {
    transactionsFetchLimit: 100,
    chart: {
      sizePx: 150,
      heightPx: 173,
      centerX: 75,
      centerY: 95,
      ringRadius: 62,
      ringStrokeWidth: 26,
      labelOffsetPx: 20,
      singleSegmentAnchorAngleDeg: -90,
      colors: {
        track: '#1F1F1F',
        interest: '#21AAC9',
        bonuses: '#4FF2E4',
        topups: '#E1F44F',
      },
    },
    search: {
      maxQueryLength: 64,
    },
    periods: {
      defaultPeriod: 'week' as const,
      weekDays: 7,
    },
    uiClassNames: {
      rootContainer: 'flex min-h-screen min-w-screen flex-col items-center gap-2.5 overflow-hidden bg-[#000] px-5 pb-[90px] pt-[115px]',
      contentContainer: 'flex w-full max-w-[361px] flex-col items-center gap-5',
      topSection: 'flex w-full flex-col items-start gap-5',
      searchContainer: 'flex w-full items-center gap-2.5 rounded-[100px] bg-[#151515] px-[15px] py-2.5',
      searchInput: 'font-inter w-full bg-transparent text-base font-medium text-[#FFF] placeholder:text-[#565656] outline-none',
      toolbarRow: 'flex w-full items-center gap-2.5',
      toolbarIconButton: 'flex items-center justify-center rounded-[100px] bg-[#151515] px-[15px] py-[5px] transition-opacity hover:opacity-90 active:opacity-80',
      toolbarChipActive: 'cursor-pointer flex items-center gap-2.5 rounded-[100px] bg-[#151515] px-[15px] py-[5px] transition-opacity hover:opacity-90 active:opacity-80',
      toolbarChipActiveSelected: 'cursor-default flex items-center gap-2.5 rounded-[100px] bg-[#161C25] px-[15px] py-[5px]',
      toolbarChipActiveText: 'font-inter text-base font-medium text-[#007CFF]',
      toolbarChipInactiveText: 'font-inter text-base font-medium text-[#FFF]',
      summarySection: 'flex w-full flex-col items-start gap-[30px]',
      summaryHeader: 'flex w-full flex-col items-start gap-1.5',
      summaryValueText: 'font-inter text-[26px] font-bold text-[#FFF]',
      summaryLabelText: 'font-inter text-[17px] font-medium text-[#ADADAD]',
      chartWrap: 'flex w-full items-center justify-center',
      periodSection: 'flex w-full flex-col items-start gap-5',
      periodTabsWrap: 'flex w-fit items-center rounded-[100px] bg-[#151515] p-1',
      periodTabBase: 'cursor-pointer rounded-[100px] px-[15px] py-[5px] text-base font-medium transition-opacity hover:opacity-90 active:opacity-80',
      periodTabActive: 'bg-[#2D2D2D] text-[#FFF]',
      periodTabInactive: 'bg-[#151515] text-[#FFF]',
      categoriesList: 'grid w-full grid-cols-2 gap-x-5 gap-y-[15px]',
      categoriesRow: 'flex min-w-0 items-center justify-start gap-[5px]',
      categoriesLeft: 'flex items-center gap-[5px]',
      categoriesIconBadge: 'flex h-6 w-6 items-center justify-center rounded-[100px]',
      categoriesTitleText: 'font-inter text-[15px] font-medium text-[#ADADAD]',
      categoriesAmountText: 'font-inter text-[15px] font-medium text-[#ADADAD]',
      historyListSection: 'flex w-full flex-col items-start gap-5',
      historyDaySection: 'flex w-full flex-col items-start gap-[15px]',
      historyDayHeader: 'flex w-full items-center justify-between',
      historyDayTitle: 'font-inter text-[21px] font-bold text-[#FFF]',
      historyDayTotal: 'font-inter text-base font-medium text-[rgba(173,173,173,0.50)]',
      historyRow: 'flex w-full items-center justify-between rounded-[20px] px-0 py-2.5',
      historyLeftColumn: 'flex w-fit items-center gap-2.5',
      historyIconWrap: 'flex h-12 w-12 items-center justify-center overflow-hidden rounded-[100px] bg-[#2D2D2D] p-[9px]',
      historyTextColumn: 'flex w-fit flex-col items-start justify-center',
      historyTitleText: 'font-inter w-fit text-base font-medium text-[#FFF]',
      historySubtitleText: 'font-inter w-fit text-[15px] font-medium text-[#ADADAD]',
      historyAmountColumn: 'flex w-fit flex-col items-end justify-center',
      historyAmountText: 'font-inter w-full text-right text-base font-medium text-[#0F7]',
      historyPartyText: 'font-inter w-full text-right text-[15px] font-medium text-[#ADADAD]',
      emptyStateCard: 'flex w-full items-center justify-center rounded-[25px] bg-[#2B2B2C] px-4 py-6',
      emptyStateText: 'font-inter text-center text-sm text-[#ADADAD]',
      searchIcon: 'h-5 w-5',
      toolbarIcon: 'h-5 w-[21px]',
      filterClearIcon: 'h-2.5 w-2.5',
      historyIcon: 'h-[30px] w-[30px] text-[#007CFF]',
      categoryInterestBadge: 'bg-[#21AAC9]',
      categoryBonusesBadge: 'bg-[#4FF2E4]',
      categoryTopupsBadge: 'bg-[#E1F44F]',
    },
  },
  transactionDetailsModal: {
    uiClassNames: {
      sheet: 'flex w-full flex-col items-center overflow-y-auto rounded-[40px] bg-[#1C1C1E] px-5 pb-[30px] pt-[30px] shadow-[0_20px_48px_rgba(0,0,0,0.45)]',
      content: 'flex w-full max-w-[361px] flex-col items-start gap-[30px]',
      header: 'flex h-[38px] w-full items-center justify-between',
      headerTitleText: 'font-inter text-[21px] font-bold text-[#FFF]',
      mainSection: 'flex w-full flex-col items-center gap-[50px]',
      heroSection: 'flex w-full flex-col items-center gap-[30px]',
      heroContent: 'flex w-full flex-col items-center gap-5',
      heroIconWrap: 'flex h-[100px] w-[100px] items-center justify-center rounded-[100px] bg-[#2D2D2D]',
      heroIcon: 'h-[56px] w-[56px] text-[#007CFF]',
      heroTitleWrap: 'flex w-full flex-col items-center gap-2.5',
      heroTitleText: 'font-inter w-full text-center text-[19px] font-medium text-[#FFF]',
      categoryPill: 'flex w-fit items-center justify-center gap-2.5 rounded-[100px] bg-[#2C2C2E] px-5 py-[5px]',
      categoryIconWrap: 'flex h-5 w-5 items-center justify-center rounded-[100px]',
      categoryIcon: 'h-2.5 w-2.5',
      categoryText: 'font-inter text-[15px] font-medium text-[#007CFF]',
      amountText: 'font-inter text-[32px] font-bold',
      detailsSection: 'flex w-full flex-col items-start gap-[25px]',
      detailsTitleText: 'font-inter w-full text-[19px] font-bold text-[#FFF]',
      detailsRows: 'flex w-full flex-col items-start gap-[25px]',
      partyRow: 'flex w-full items-center justify-between',
      partyInfo: 'flex w-[87px] flex-col items-start gap-2.5',
      partyLabelText: 'font-inter w-full text-sm font-medium text-[#ADADB4]',
      partyValueWrap: 'flex w-full flex-col items-start gap-[5px]',
      partyNameText: 'font-inter w-full text-base font-medium text-[#FFF]',
      partyUsernameText: 'font-inter w-full text-xs font-medium text-[#ADADB4]',
      avatar: 'flex h-12 w-12 shrink-0 items-center justify-center rounded-[100px] bg-[#FFF]',
      avatarText: 'font-inter text-base font-bold text-[#121212]',
      amountRow: 'flex w-full items-center justify-between',
      amountInfo: 'flex w-[87px] flex-col items-start gap-2.5',
      amountValueWrap: 'flex w-full flex-col items-start gap-[5px]',
      amountValueText: 'font-inter w-full text-base font-medium text-[#FFF]',
      categoryTonePurchase: 'bg-[#666666] text-white',
      categoryToneGift: 'bg-[#F2C14F] text-white',
      categoryToneTopup: 'bg-[#21AAC9] text-white',
      categoryToneRefund: 'bg-[#34C759] text-white',
      categoryToneAdminAdd: 'bg-[#4FF2E4] text-[#121212]',
      categoryToneAdminSubtract: 'bg-[#F7782F] text-white',
    },
  },
  referralsPage: {
    referralCommissionPercent: 15,
    commissionTiers: [
      { percent: 15, minActiveReferrals: 10 },
      { percent: 25, minActiveReferrals: 15 },
      { percent: 35, minActiveReferrals: 25 },
      { percent: 50, minActiveReferrals: 45 },
    ],
    activeSubscriptionStatuses: ['active'],
    uiClassNames: {
      rootContainer: 'flex min-h-screen min-w-screen flex-col items-center gap-2.5 overflow-hidden bg-[#000] px-5 pb-[120px] pt-[115px]',
      contentContainer: 'flex w-full max-w-[361px] flex-col items-center gap-[25px]',
      statsSection: 'flex w-full flex-col items-center gap-[15px]',
      statsMainCard: 'flex w-full items-start gap-2.5 overflow-hidden rounded-[25px] bg-[#2C2C2E] px-5 py-[15px]',
      statsMainCardContent: 'flex w-full flex-col items-start gap-2.5',
      statsRow: 'flex w-full items-center gap-2.5',
      statsSmallCard: 'flex w-full items-center gap-2.5 overflow-hidden rounded-[25px] bg-[#2C2C2E] p-[15px]',
      statsSmallCardButton: 'flex w-full items-center gap-2.5 overflow-hidden rounded-[25px] bg-[#2C2C2E] p-[15px] text-left transition-opacity hover:opacity-90 active:opacity-80',
      statsSmallCardContent: 'flex w-full flex-col items-start gap-2.5',
      statsLabelText: 'font-inter w-fit text-base font-medium text-[#ADADB4]',
      statsValueText: 'font-inter w-fit text-[21px] font-medium text-[#FFF]',
      statsHintText: 'font-inter w-fit text-base font-medium text-[rgba(173,173,180,0.50)]',
      statsAccentValueText: 'font-inter w-fit text-[21px] font-medium text-[#0091FF]',
      sectionHintText: 'font-inter w-full text-center text-sm text-[#ADADB4]',
      linkSection: 'flex w-full flex-col items-center gap-5',
      linkSectionHeader: 'flex w-full items-center justify-between',
      linkSectionTitle: 'font-inter w-fit text-base font-medium text-[#ADADB4]',
      linkSourceButton: 'flex w-fit items-center justify-end gap-[5px] transition-opacity hover:opacity-90 active:opacity-80',
      linkSourceText: 'font-inter w-fit text-base font-medium text-[#FFF]',
      linkSourceIcon: 'h-3 w-2',
      linkCardButton: 'flex h-[52px] w-full items-center gap-2.5 overflow-hidden rounded-[20px] bg-[#2C2C2E] px-3.5 py-0 transition-opacity hover:opacity-90 active:opacity-80',
      linkCardContent: 'flex h-6 w-full items-center justify-between gap-2.5',
      linkValueText: 'font-inter w-full truncate text-left text-base text-[#FFF]',
      linkCopyIcon: 'h-5 w-5 shrink-0',
      rulesCard: 'flex w-full flex-col items-center gap-2.5 overflow-hidden rounded-[25px] bg-[#2C2C2E] pb-[15px] pl-[15px] pr-0 pt-[15px]',
      rulesCardContent: 'flex w-full flex-col items-end gap-2.5',
      rulesItem: 'flex w-full flex-col items-start gap-[5px] pr-[5px]',
      rulesItemTitle: 'font-inter w-full text-base font-medium text-[#FFF]',
      rulesItemText: 'font-inter w-full text-[15px] text-[#ADADB4]',
      rulesDivider: 'h-px w-full bg-[#404040]',
      referralsListButton: 'flex h-[49px] w-full items-center gap-2.5 overflow-hidden rounded-[100px] bg-[#2C2C2E] px-4 py-0 transition-opacity hover:opacity-90 active:opacity-80',
      referralsListButtonContent: 'flex w-full items-center justify-between',
      referralsListLeftGroup: 'flex w-fit items-center gap-2.5',
      referralsListIcon: 'h-7 w-7',
      referralsListText: 'font-inter text-[17px] font-medium text-[#FFF]',
      referralsListChevron: 'h-3 w-[7px]',
    },
  },
  referralCommissionModal: {
    uiClassNames: {
      ...referralModalSharedUiClassNames,
      sheet: 'flex h-[calc(62dvh+150px)] max-h-[calc(100dvh-30px)] w-full flex-col items-center gap-2.5 overflow-y-auto rounded-[40px] bg-[#1C1C1E] px-0 pb-[50px] pt-0',
      layout: 'flex w-full max-w-[393px] flex-col items-center gap-[15px] px-4 pt-[15px]',
      content: 'flex w-full flex-col items-start gap-[50px]',
      topSection: 'flex w-full flex-col items-start gap-[30px]',
      topCardWrap: 'flex w-full flex-col items-center gap-5',
      topCard: 'flex w-full flex-col items-start gap-2.5 overflow-hidden rounded-[25px] bg-[#2C2C2E] px-[15px] py-5',
      topCardContent: 'flex w-full flex-col items-start gap-[15px]',
      topCardValueGroup: 'flex w-full flex-col items-start gap-1.5',
      topCardValueText: 'font-inter w-fit text-[19px] font-bold text-[#FFF]',
      topCardLabelText: 'font-inter w-fit text-[15px] font-medium text-[#ADADB4]',
      topHintButton: 'flex w-full items-center justify-center gap-2.5',
      topHintText: 'font-inter w-full text-center text-sm font-medium text-[#ADADB4]',
      section: 'flex w-full flex-col items-start gap-[15px]',
      sectionTitleText: 'font-inter w-full text-[19px] font-bold text-[#FFF]',
      detailsCard: 'flex w-full flex-col items-center gap-2.5 overflow-hidden rounded-[25px] bg-[#2C2C2E] pb-[5px] pl-[15px] pr-0 pt-[5px]',
      detailsCardContent: 'flex w-full flex-col items-end',
      detailsRow: 'flex h-[42px] w-full items-center justify-between pr-[15px]',
      detailsLabelText: 'font-inter w-full truncate text-base text-[#FFF]',
      detailsValueText: 'font-inter w-full truncate text-right text-base text-[#ADADB4]',
      detailsDivider: 'h-px w-full bg-[#404040]',
      termsSection: 'flex w-full flex-col items-start gap-[15px]',
      termsList: 'flex w-full flex-col items-center',
      termsRow: 'flex w-full items-center justify-center gap-2.5 rounded-[20px] px-0 py-2.5',
      termsRowContent: 'flex w-full items-center justify-between',
      termsLeft: 'flex w-fit items-center gap-2.5',
      termsPercentBadge: 'flex h-12 w-12 flex-col items-center justify-center gap-2.5 overflow-hidden rounded-[100px] bg-[#2D2D2D]',
      termsPercentText: 'font-inter w-fit text-[13px] font-bold text-[#2F7CF7]',
      termsTitleText: 'font-inter w-fit text-base font-medium text-[#FFF]',
      termsRight: 'flex w-fit flex-col items-end justify-center',
      termsThresholdText: 'font-inter w-full text-right text-base font-medium text-[#2F7CF7]',
    },
  },
  referralTotalEarningsModal: {
    itemsFetchLimit: 100,
    uiClassNames: {
      ...referralModalSharedUiClassNames,
      sheet: 'flex h-[calc(62dvh+150px)] max-h-[calc(100dvh-30px)] w-full flex-col items-center gap-2.5 overflow-y-auto rounded-[40px] bg-[#1C1C1E] px-0 pb-[50px] pt-0',
      layout: 'flex w-full max-w-[393px] flex-col items-center gap-[15px] px-4 pt-[15px]',
      content: 'flex w-full flex-col items-start gap-[15px]',
      topCard: 'flex w-full flex-col items-start gap-2.5 overflow-hidden rounded-[25px] bg-[#2C2C2E] px-[15px] py-5',
      topCardContent: 'flex w-full flex-col items-start gap-[15px]',
      topCardValueText: 'font-inter w-fit text-[19px] font-bold text-[#FFF]',
      topCardLabelText: 'font-inter w-fit text-[15px] font-medium text-[#ADADB4]',
      loadingWrap: 'flex w-full items-center justify-center rounded-[20px] px-0 py-2.5',
      loadingText: 'font-inter text-[15px] font-medium text-[#ADADB4]',
      list: 'flex w-full flex-col items-center',
      listRow: 'flex w-full items-center justify-center gap-2.5 rounded-[20px] px-0 py-2.5',
      listRowContent: 'flex w-full items-center justify-between',
      listLeftGroup: 'flex w-fit items-center gap-2.5',
      listAvatar: 'flex h-12 w-12 items-center justify-center overflow-hidden rounded-[100px] bg-[#FFF]',
      listAvatarImage: 'h-full w-full object-cover',
      listIdentityColumn: 'flex w-fit flex-col items-start justify-center',
      listNameText: 'font-inter w-fit text-base font-medium text-[#FFF]',
      listHandleButton: 'cursor-pointer text-nowrap flex justify-center items-center gap-2.5 w-fit',
      listHandleText: 'font-inter w-fit text-[15px] font-medium text-[#ADADB4]',
      listMetaColumn: 'flex w-fit flex-col justify-center items-end',
      listAmountText: 'font-inter w-full text-right text-base font-medium text-[#2F7CF7]',
      listDateText: 'font-inter w-full text-right text-[15px] font-medium text-[#ADADB4]',
      emptyWrap: 'flex w-full items-center justify-center rounded-[20px] px-0 py-2.5',
      emptyText: 'font-inter text-center text-[15px] text-[#ADADB4]',
    },
  },
  referralsListPage: {
    uiClassNames: {
      rootContainer: 'flex min-h-screen min-w-screen flex-col items-center gap-2.5 overflow-hidden bg-[#000] px-5 pb-[30px] pt-[115px]',
      contentContainer: 'flex w-full max-w-[361px] flex-col items-start gap-5',
      titleSection: 'flex w-full flex-col items-start gap-[15px]',
      titleText: 'font-inter w-full text-[21px] font-bold text-[#FFF]',
      listContainer: 'flex w-full flex-col items-center',
      listRowButton: 'flex w-full items-center justify-center gap-2.5 rounded-[20px] px-0 py-2.5 text-left transition-opacity hover:opacity-90 active:opacity-80 disabled:cursor-not-allowed disabled:opacity-60',
      listRowContent: 'flex w-full items-center justify-between',
      listLeftGroup: 'flex w-fit items-center gap-2.5',
      listAvatar: 'h-12 w-12 overflow-hidden rounded-[100px] bg-[#FFF]',
      listIdentityColumn: 'flex w-fit flex-col items-start justify-center',
      listNameText: 'font-inter w-fit text-base font-medium text-[#FFF]',
      listHandleButton: 'flex w-fit items-center justify-center gap-2.5',
      listHandleText: 'font-inter w-fit text-[15px] font-medium text-[#ADADAD]',
      listMetaColumn: 'flex w-fit flex-col items-end justify-center',
      listStatusText: 'font-inter w-full text-right text-base font-medium',
      listStatusActiveText: 'text-[#0F7]',
      listStatusInactiveText: 'text-[#ADADAD]',
      listDateText: 'font-inter w-full text-right text-[15px] font-medium text-[#ADADAD]',
      emptyContainer: 'flex w-full flex-col items-start gap-10',
      emptyVisualWrap: 'flex w-full flex-col items-center gap-5 px-0 py-2.5',
      emptyIcon: 'h-[100px] w-[100px]',
      emptyTextWrap: 'flex w-full flex-col items-center',
      emptyText: 'font-inter w-full text-center text-base font-medium text-[#ADADAD]',
      emptyLinkSection: 'flex w-full flex-col items-center gap-2.5',
      emptyLinkHeader: 'flex w-full items-center justify-between',
      emptyLinkTitleText: 'font-inter w-fit text-[17px] text-[#ADADAD]',
      emptyLinkSourceButton: 'flex w-fit items-center justify-end gap-[5px] transition-opacity hover:opacity-90 active:opacity-80',
      emptyLinkSourceText: 'font-inter w-fit text-base text-[#FFF]',
      emptyLinkSourceIcon: 'h-3 w-2',
      emptyLinkCard: 'flex h-[52px] w-full items-center gap-2.5 overflow-hidden rounded-[20px] bg-[#2C2C2E] p-3.5',
      emptyLinkCardContent: 'flex h-6 w-full items-center justify-between',
      emptyLinkValueText: 'font-inter w-[300px] truncate text-base text-[#FFF]',
      emptyLinkCopyIcon: 'h-5 w-5 shrink-0',
    },
  },
  referralDetailsModal: {
    expensesPreviewLimit: 20,
    uiClassNames: {
      overlay: 'fixed inset-0 z-[1500] flex items-end justify-center bg-black/70 px-0 pb-0 pt-[30px]',
      sheet: 'flex max-h-[calc(100dvh-30px)] w-full flex-col items-center gap-[15px] overflow-y-auto rounded-[40px] bg-[#1C1C1E] px-5 pb-[30px] pt-[30px]',
      layout: 'flex w-full max-w-[353px] flex-col items-center gap-[15px]',
      header: 'flex h-[38px] w-full items-center justify-between',
      body: 'flex w-full flex-col items-center gap-[50px]',
      identitySection: 'flex w-full flex-col items-center gap-5',
      avatar: 'h-[100px] w-[100px] rounded-[100px] bg-[#FFF]',
      identityTextGroup: 'flex w-full flex-col items-center gap-2.5',
      identityNameWrap: 'flex w-fit items-center gap-2.5',
      identityNameText: 'font-inter w-fit text-[19px] font-medium text-[#FFF]',
      identityHandleWrap: 'flex w-fit items-center gap-2.5',
      identityHandleText: 'font-inter w-fit text-base font-medium text-[#ADADB4]',
      statusPill: 'flex w-32 items-center justify-center gap-2.5 overflow-hidden rounded-[100px] bg-[#2C2C2E] px-2.5 py-[5px]',
      statusText: 'font-inter w-fit text-[15px] font-medium',
      statusTextActive: 'text-[#0F7]',
      statusTextInactive: 'text-[#ADADB4]',
      sections: 'flex w-full flex-col items-start gap-[50px]',
      section: 'flex w-full flex-col items-start gap-[15px]',
      sectionTitle: 'font-inter w-full text-[19px] font-bold text-[#FFF]',
      detailsCard: 'flex w-full flex-col items-center gap-2.5 overflow-hidden rounded-[25px] bg-[#2C2C2E] pl-[15px] pr-0 py-[5px]',
      detailsCardContent: 'flex w-full flex-col items-end',
      detailsRow: 'flex h-[42px] w-full items-center justify-between pr-[15px]',
      detailsRowLabel: 'font-inter w-full truncate text-base text-[#FFF]',
      detailsRowValue: 'font-inter w-full truncate text-right text-base text-[#ADADB4]',
      detailsDivider: 'h-px w-full bg-[#404040]',
      expensesList: 'flex w-full flex-col items-center',
      expenseRow: 'flex w-full items-center justify-center gap-2.5 rounded-[20px] px-0 py-2.5',
      expenseRowContent: 'flex w-full items-center justify-between',
      expenseLeftGroup: 'flex w-fit items-center gap-2.5',
      expenseIconWrap: 'flex h-12 w-12 items-center justify-center overflow-hidden rounded-[100px] bg-[#2D2D2D] px-[9px] py-2.5',
      expenseIcon: 'h-7 w-[30px] shrink-0',
      expenseInfoColumn: 'flex w-fit flex-col items-start justify-center',
      expenseTitleText: 'font-inter w-fit text-base font-medium text-[#FFF]',
      expenseTypeText: 'font-inter w-fit text-[15px] font-medium text-[#ADADB4]',
      expenseMetaColumn: 'flex w-fit flex-col items-end justify-center',
      expenseAmountText: 'font-inter w-full text-right text-base font-medium text-[#2F7CF7]',
      expenseMerchantText: 'font-inter w-full text-right text-[15px] font-medium text-[#ADADB4]',
      emptyExpensesText: 'font-inter w-full text-center text-[15px] font-medium text-[#ADADB4]',
    },
  },
  payment: {
    currencySymbol: '₽',
    metadataSource: 'miniapp',
    purposes: {
      quickBuySubscription: 'quick_buy_subscription',
      subscriptionExtendTime: 'subscription_extend_time',
      subscriptionAddDevice: 'subscription_add_device',
    },
    defaultDurationDays: 30,
    defaultDurationMonths: 1,
    defaultDeviceCount: 1,
    defaultProPlanId: '12',
    proPlans: [
      { id: '1', durationMonths: 1, priceRub: 240, oldPriceRub: null, discountPercent: 0, isPopular: false },
      { id: '3', durationMonths: 3, priceRub: 612, oldPriceRub: 720, discountPercent: 15, isPopular: false },
      { id: '6', durationMonths: 6, priceRub: 1080, oldPriceRub: 1440, discountPercent: 25, isPopular: false },
      { id: '12', durationMonths: 12, priceRub: 1440, oldPriceRub: 2880, discountPercent: 50, isPopular: true },
    ],
    balanceSuccessRedirectDelayMs: 1500,
    externalSuccessRedirectDelayMs: 2000,
    pendingSuccessRevealDelayMs: 300,
    miniAppCloseDelayMs: 150,
    handoff: {
      pollIntervalMs: 400,
      timeoutMs: 60_000,
    },
    statusPolling: {
      intervalMs: 2500,
      timeoutMs: 5 * 60 * 1000,
    },
    successSound: {
      enabled: true,
      replayGuardMs: 2400,
      sourceUrl: '/sounds/google-pay-success-sound-effect.mp3',
      sourceVolume: 1,
      waveform: 'sine',
      frequencyHz: 880,
      durationMs: 120,
      volume: 0.046,
      attackMs: 4,
      releaseMs: 90,
      detuneCents: 0,
      secondToneEnabled: true,
      secondToneOffsetMs: 82,
      secondToneFrequencyHz: 1320,
      secondToneDurationMs: 105,
      secondToneDetuneCents: 0,
      secondToneVolumeMultiplier: 0.9,
      toneSequence: [
        {
          offsetMs: 0,
          durationMs: 96,
          startFrequencyHz: 1180,
          endFrequencyHz: 1100,
          volumeMultiplier: 1,
          detuneCents: 0,
        },
        {
          offsetMs: 64,
          durationMs: 132,
          startFrequencyHz: 1760,
          endFrequencyHz: 1480,
          volumeMultiplier: 0.72,
          detuneCents: 0,
        },
        {
          offsetMs: 136,
          durationMs: 72,
          startFrequencyHz: 2480,
          endFrequencyHz: 2140,
          volumeMultiplier: 0.24,
          detuneCents: 0,
        },
      ],
    },
    fallbackPeriodLabel: '-',
  },
  checkout: {
    minDeviceCount: 2,
    baseIncludedDevices: 2,
    initialDeviceCount: 2,
    sheetMaxHeight: 'calc(100dvh - 30px)',
    paymentSuccessAnimation: {
      durationMs: 700,
      holdAfterMorphMs: 1500,
      iconFadeDurationMs: 120,
      iconDrawDurationMs: 350,
      easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
      textShiftYPx: 6,
      iconSizeRatio: 0.644,
      iconStrokeWidthPx: 2.2,
      buttonHeightPx: 52,
      buttonExpandedHorizontalPaddingPx: 40,
    },
    uiClassNames: {
      rootContainer: 'flex w-full flex-col items-center gap-[15px] overflow-hidden rounded-t-[40px] bg-[#1C1C1E] px-5 pb-[30px] pt-[30px]',
      closeRow: 'flex h-[38px] w-full items-center justify-end',
      contentContainer: 'flex w-full flex-col items-center gap-10',
      headerContainer: 'flex w-full flex-col items-center gap-[30px]',
      iconSize: 'h-[100px] w-[100px] shrink-0',
      textContainer: 'flex w-full flex-col items-center gap-[5px]',
      titleText: 'w-full text-center font-inter text-[21px] font-bold text-[#FFF]',
      descriptionText: 'w-full text-center font-inter text-base font-medium text-[#ADADB4]',
      sliderCard: 'flex w-full flex-col items-start gap-[19px] overflow-hidden rounded-[25px] bg-[#2C2C2E] p-[15px]',
      sliderTopRow: 'flex w-full items-center justify-between',
      sliderTopLabel: 'font-inter text-base text-[#FFF]',
      sliderTopValue: 'font-inter text-base text-[#0091FF]',
      sliderDivider: 'h-px w-full bg-[#404040]',
      sliderBlock: 'flex w-full flex-col items-center gap-[9px]',
      sliderTrackRow: 'flex w-full items-center',
      sliderTrackBase: 'h-1.5 w-full appearance-none rounded-[10px] bg-[#404040]',
      sliderLabelsRow: 'flex w-full items-center justify-between',
      sliderLabelText: 'font-inter text-base font-medium tabular-nums text-[#ADADB4]',
      saveButton: 'cursor-pointer flex w-full items-center justify-center gap-2.5 overflow-hidden rounded-[100px] bg-[#0091FF] px-[15px] py-3.5 transition-opacity hover:opacity-90 active:opacity-80 disabled:cursor-not-allowed disabled:opacity-60',
      saveButtonText: 'font-inter text-[17px] font-medium text-[#FFF]',
    },
    sliderStyles: {
      activeTrackColor: '#0091FF',
      inactiveTrackColor: '#404040',
      trackHeightPx: 6,
      trackRadiusPx: 10,
      thumbBackground: '#FFF',
      thumbBorderColor: '#404040',
      thumbWidthPx: 38,
      thumbHeightPx: 24,
      thumbRadiusPx: 100,
    },
  },
  ui: {
    avatarPalette: ['#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8', '#F7DC6F', '#BB8FCE', '#85C1E2'],
    copyFeedbackDurationMs: 2000,
    notificationDurationMs: 2500,
    feedbackBottomPx: 96,
    safeArea: {
      telegram: {
        mainScreenTopPaddingPx: 48,
        mainScreenBottomPaddingPx: 128,
        mainScreenHorizontalPaddingPx: 16,
        rootWithBottomNavBottomPaddingPx: 128,
        rootWithBottomNavTopPaddingPx: 48,
        appLayoutHeaderTopPaddingPx: 24,
        appLayoutMainTopPaddingPx: 20,
        appLayoutMainBottomPaddingPx: 112,
        appLayoutHorizontalPaddingPx: 16,
        mobileMenuHorizontalPaddingPx: 24,
        mobileMenuBottomSafeOffsetPx: 0,
        bottomNavHorizontalPaddingPx: 16,
        bottomNavBottomSafeOffsetPx: 8,
      },
      browser: {
        mainScreenTopPaddingPx: 24,
        mainScreenBottomPaddingPx: 96,
        mainScreenHorizontalPaddingPx: 16,
        rootWithBottomNavBottomPaddingPx: 96,
        rootWithBottomNavTopPaddingPx: 24,
        appLayoutHeaderTopPaddingPx: 16,
        appLayoutMainTopPaddingPx: 16,
        appLayoutMainBottomPaddingPx: 96,
        appLayoutHorizontalPaddingPx: 16,
        mobileMenuHorizontalPaddingPx: 24,
        mobileMenuBottomSafeOffsetPx: 0,
        bottomNavHorizontalPaddingPx: 16,
        bottomNavBottomSafeOffsetPx: 16,
      },
    },
    colors: {
      pageBg: 'bg-[#121212]',
      pageBgHex: '#121212',
      textPrimaryHex: '#ffffff',
      iconSurfaceText: 'text-[#121212]',
      textPrimary: 'text-[#FFF]',
      textSecondary: 'text-[#B3B3B3]',
      textMuted: 'text-[#999]',
      textDanger: 'text-red-400',
      surfaceMid: 'bg-[#333]',
      surfaceDark: 'bg-[#1F1F1F]',
      surfaceSuccess: 'bg-[#113322]',
      surfaceError: 'bg-[#3A1B1B]',
      accentBlueBg: 'bg-[#0AF]',
      accentBlueText: 'text-[#0AF]',
      accentBlueBorder: 'border-[#0AF]',
      surfaceDarker: 'bg-[#222]',
      secondaryButtonBg: 'bg-[#163044]',
      dividerBg: 'bg-[rgba(179,179,179,0.25)]',
      borderSubtle: 'border-[#2E2E2E]',
      borderStrong: 'border-[#3D3D3D]',
      successBorder: 'border-[#1E6E49]',
      errorBorder: 'border-[#7A2E2E]',
      toastOverlayBg: 'bg-[rgba(0,0,0,0.80)]',
      modalHandleBg: 'bg-[#D9D9D9]',
      surfaceMidHover: 'hover:bg-[#444]',
    },
    layout: {
      pageTopPadding: 'pt-[25px]',
      contentGap: 'gap-[60px]',
      mainContentWidth: 'w-[361px]',
      mainContentMaxWidth: 'max-w-[361px]',
      sectionGap: 'gap-[25px]',
      surfaceRounded: 'rounded-[25px]',
      surfaceRoundedSm: 'rounded-[20px]',
      userInfoBlockPadding: 'pt-[25px] pr-[15px] pb-[50px] pl-4',
    },
    button: {
      height: 'h-[52px]',
      rounded: 'rounded-[100px]',
      px: 'px-[45px]',
      textSize: 'text-[17px]',
      focusRing: 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[#0AF] focus-visible:ring-offset-[#121212]',
    },
    loader: {
      trackStrokeHex: '#B3B3B3',
      spinnerStrokeHex: '#121212',
      trackOpacity: 0.3,
      loginTrackStrokeHex: '#222222',
      loginSpinnerStrokeHex: '#00AAFF',
      loginTrackOpacity: 0.15,
    },
    panels: {
      surface: 'rounded-2xl border border-black/5 bg-tg-bg p-4 shadow-sm',
      success: 'rounded-2xl border border-green-200 bg-green-50 p-4 text-green-700 shadow-sm',
      error: 'rounded-2xl border border-red-200 bg-red-50 p-4 text-red-700 shadow-sm',
      inset: 'rounded-xl bg-tg-secondary-bg/70 p-3',
      fallbackSurface: 'rounded-lg bg-tg-bg p-6 text-center',
    },
    banner: {
      iconContainerSize: 'w-[119px] h-[148px]',
      titleTextSize: 'text-[22px]',
      bodyTextSize: 'text-[17px]',
      descriptionGap: 'gap-2.5',
    },
    modal: {
      sheetRoundedTop: 'rounded-t-[20px]',
      handleRounded: 'rounded-[10px]',
      handleSize: 'w-10 h-1',
      appRootSelector: '#root',
    },
    feedback: {
      dialogContentPadding: 'px-6 pb-6 pt-2',
      inputRounded: 'rounded-lg',
      inputPadding: 'px-3 py-2',
      actionsGap: 'gap-2',
      actionButtonRounded: 'rounded-lg',
      actionButtonPadding: 'px-3 py-2',
      actionButtonText: 'text-sm font-semibold',
      toastStackZIndex: 'z-[12000]',
    },
    icons: {
      surfaceHex: '#333333',
      foregroundHex: '#FFFFFF',
      accentHex: '#0091FF',
      coinFullSize: 'w-[70px] h-[70px]',
      coinBadgeContainerSize: 'w-24 h-24',
    },
    copyToast: {
      containerGap: 'gap-[13px]',
      containerRounded: 'rounded-[15px]',
      containerWidth: 'w-[361px]',
      containerHeight: 'h-[47px]',
      iconSize: 'w-[23px] h-[23px]',
    },
  },
  plan: {
    uiClassNames: {
      section: 'flex w-full flex-col items-start gap-[15px]',
      packageLabelRow: 'flex w-full items-center justify-start',
      packageLabelText: 'font-inter text-[17px] text-[#ADADB4]',
      listContainer: 'grid h-[398px] w-full grid-cols-2 auto-rows-[194px] gap-2.5 overflow-y-auto pr-0.5',
      cardBase:
        'flex h-full w-full flex-col items-center justify-center gap-2.5 overflow-hidden rounded-[25px] border-2 bg-[#2C2C2E] px-[15px] py-[15px] text-center transition-opacity hover:opacity-90 active:opacity-80',
      cardUnselected: 'border-transparent',
      cardSelected: 'border-[#0091FF]',
      cardContent: 'flex h-full w-full flex-col items-center justify-between',
      durationGroup: 'flex w-full flex-col items-center',
      durationText: 'font-inter text-[40px] font-bold leading-[47px] text-[#FFF]',
      monthText: 'font-inter text-base text-[#FFF]',
      savingsText: 'font-inter text-base text-[#0091FF]',
      priceGroup: 'flex w-full flex-col items-center',
      discountedPriceText: 'font-inter text-base text-[#0091FF]',
      regularPriceText: 'font-inter text-base text-[#FFF]',
      oldPriceText: 'line-through',
      perMonthText: 'font-inter text-[15px] text-[#ADADB4]',
    },
  },
  planPage: {
    uiClassNames: {
      rootContainer: 'flex min-h-screen min-w-screen flex-col items-center gap-2.5 overflow-hidden bg-[#000] px-5 pb-[90px] pt-[115px]',
      contentContainer: 'flex w-full max-w-[361px] flex-col items-center gap-[60px]',
      headerSection: 'flex w-full flex-col items-center gap-[5px]',
      titleText: 'font-inter w-full text-center text-[21px] font-bold text-[#FFF]',
      subtitleText: 'font-inter w-full text-center text-sm text-[#ADADB4]',
      mainSection: 'flex w-full flex-col items-start gap-[15px]',
      skeletonCardContainer: 'grid h-[398px] w-full grid-cols-2 auto-rows-[194px] gap-2.5',
      skeletonCardBg: 'bg-[#222]',
      continueButton:
        'cursor-pointer flex w-full items-center justify-center overflow-hidden rounded-[100px] bg-[#0091FF] px-0 py-3.5 transition-opacity hover:opacity-90 active:opacity-80',
      continueButtonText: 'font-inter text-[17px] font-medium text-[#FFF]',
    },
  },
  subscriptionDetail: {
    uiClassNames: {
      rootPadding: 'px-8 pb-8',
      rootTopPadding: 'pt-[10px]',
      panelGap: 'gap-[25px]',
      iconBoxSize: 'w-[100px] h-[100px]',
      iconBoxRounded: 'rounded-[50px]',
      iconSize: 'w-[60px] h-[60px]',
      detailsGap: 'gap-5',
      listGap: 'gap-2.5',
      accessBoxRounded: 'rounded-[25px]',
      accessBoxPadding: 'p-1.5',
      keyButtonRounded: 'rounded-[20px]',
      keyButtonPadding: 'p-3.5',
      guideButtonPadding: 'py-2 px-2.5',
      actionButtonsGap: 'gap-[9px]',
    },
  },
  subscriptionQrPage: {
    link: {
      happAddPrefix: 'happ://add/',
      fallbackAccessBaseUrl: envConfig.subscriptionAccessBaseUrl,
    },
    qr: {
      sizePx: 251,
      marginSize: 0,
      color: '#000000',
      dataModulesStyle: 'rounded',
      dataModulesRandomSize: false,
      finderPatternOuterStyle: 'rounded-lg',
      finderPatternInnerStyle: 'rounded-lg',
      svgShapeRendering: 'geometricPrecision',
      logoSizePx: 69,
      logoExcavate: true,
    },
    uiClassNames: {
      rootContainer: 'flex min-h-screen min-w-screen flex-col items-center gap-2.5 bg-[#000] px-5 pb-[70px] pt-[115px]',
      contentContainer: 'flex w-full flex-col items-center gap-[78px]',
      qrSectionContainer: 'flex w-full flex-col items-center',
      qrStackContainer: 'relative flex w-full flex-col items-center -space-y-[50px]',
      avatarOuterWrap: 'relative z-20 flex h-[105px] w-[105px] items-center justify-center overflow-hidden rounded-[100px] bg-[#FFF] p-1',
      avatarInnerWrap: 'flex h-[97px] w-[97px] items-center justify-center overflow-hidden rounded-[100px] bg-[#000]',
      avatarImage: 'h-full w-full object-cover',
      avatarFallbackText: 'font-inter text-3xl font-bold text-white',
      qrCardContainer: 'relative z-10 flex w-full flex-col items-start gap-2.5 overflow-hidden rounded-[50px] bg-[#FFF] px-[39px] pb-[25px] pt-[65px]',
      qrCardContent: 'flex w-full flex-col items-center gap-[25px]',
      qrCodeBox: 'flex h-[251px] w-[251px] items-center justify-center',
      subscriptionNameText: 'w-fit text-center font-inter text-[19px] font-bold text-[#000]',
      footerContainer: 'flex w-full flex-col items-start gap-[15px]',
      instructionText: 'w-full text-center font-inter text-sm text-[#ADADAD]',
      shareButtonBase: 'cursor-pointer text-nowrap flex h-12 w-full items-center justify-center gap-2.5 overflow-hidden rounded-[100px] bg-[#161C25] transition-transform',
      shareButtonInteractive: 'active:scale-[0.99]',
      shareButtonDisabled: 'cursor-not-allowed opacity-70',
      shareButtonText: 'w-fit font-inter text-[17px] font-medium text-[#0091FF]',
    },
  },
  subscriptionPage: {
    animation: {
      tabIndicatorDurationMs: 320,
      tabIndicatorEasing: 'cubic-bezier(0.22, 1, 0.36, 1)',
      tabIndicatorFallbackWidthPx: 112,
    },
    skeleton: {
      minVisibleMs: 280,
      tabsCount: 3,
      actionButtonsCount: 3,
    },
    uiClassNames: {
      rootPadding: 'pt-[111px] px-4 pb-6',
      rootGap: 'gap-2.5',
      sectionGap: 'gap-[25px]',
      cardGap: 'gap-5',
      cardRounded: 'rounded-[25px]',
      cardInnerPadding: 'p-1.5',
      linkRowRounded: 'rounded-[20px]',
      linkRowPadding: 'p-3.5',
      linkRowContentWidth: 'w-[321px]',
      linkTextWrapWidth: 'w-[287px]',
      linkTextHeight: 'h-6',
      linkTextWidth: 'w-[287px]',
      tabsWrapRounded: 'rounded-[100px]',
      tabsWrapPadding: 'p-1',
      tabsIndicatorInset: 'left-0 top-1 bottom-1',
      tabRounded: 'rounded-[100px]',
      tabPadding: 'py-1 px-5',
      tabButtonBg: 'bg-transparent',
      controlsGap: 'gap-2.5',
      controlsTitleWidth: 'w-[329px]',
      controlsTitlePrimaryPadding: 'pr-48',
      controlsTitleSecondaryPadding: 'pr-[178px]',
      actionButtonHeight: 'h-[52px]',
      actionButtonRounded: 'rounded-[100px]',
      actionButtonPadding: 'py-1.5 px-[45px]',
      reportButtonBg: 'bg-[#840709]',
      topCardWidth: 'w-[361px]',
      subtitleWidth: 'w-[361px]',
      summaryRowGap: 'gap-2.5',
      summaryLeftWidth: 'w-[228px]',
      summaryRightWidth: 'w-[123px]',
      packageRowHeight: 'h-[39px]',
      packageNamePillPadding: 'py-2 px-[25px]',
      packageDatePillPadding: 'py-2 px-0',
      guideCardRowPadding: 'py-[7px] px-2',
      guideCardRowWidth: 'w-[349px]',
      guideCardRowHeight: 'h-11',
      guideCardContentWidth: 'w-[329px]',
      guideCardLeftGroupGap: 'gap-1.5',
      guideCardLeftGroupWidth: 'flex-1 min-w-0',
      guideCardTitleWidth: 'w-auto',
      skeletonTitleWidth: 'w-56',
      skeletonSubtitleWidth: 'w-64',
      skeletonSummaryPrimaryWidth: 'w-28',
      skeletonSummarySecondaryWidth: 'w-24',
      skeletonPackageNameWidth: 'w-24',
      skeletonPackageDateWidth: 'w-32',
      skeletonSectionLabelWidth: 'w-40',
      skeletonLinkWidth: 'w-[260px]',
      skeletonTabWidth: 'w-24',
      skeletonActionWidth: 'w-64',
      skeletonReportWidth: 'w-56',
      regenerateLinkModalRootContainer: 'flex w-full flex-col items-center gap-2.5 overflow-hidden rounded-t-[40px] bg-[#1C1C1E] px-5 py-[30px]',
      regenerateLinkModalCloseRow: 'flex h-[38px] w-full items-center justify-end',
      regenerateLinkModalBodyContainer: 'flex w-full flex-col items-center gap-[30px]',
      regenerateLinkModalHeaderContainer: 'flex w-full flex-col items-center gap-[15px]',
      regenerateLinkModalTextContainer: 'flex w-full flex-col items-center gap-2.5',
      regenerateLinkModalTitleText: 'w-full text-center font-inter text-[21px] font-bold text-[#FFF]',
      regenerateLinkModalDescriptionText: 'w-full text-center font-inter text-sm font-medium text-[#ADADB4]',
      regenerateLinkModalActionsContainer: 'flex w-full flex-col items-center gap-2.5',
      regenerateLinkModalActionButton:
        'cursor-pointer text-nowrap flex h-12 w-full items-center justify-center gap-2.5 overflow-hidden rounded-[100px] bg-[#2C2C2E] px-[15px] py-0 transition-transform active:scale-[0.99] disabled:cursor-not-allowed disabled:opacity-60',
      regenerateLinkModalActionButtonText: 'w-fit font-inter text-[17px] font-medium text-[#0091FF]',
    },
  },
  subscriptionAutopayment: {
    defaultAutopaymentLeadDays: 5,
    defaultChargeLeadDays: 1,
    chargeLeadDayOptions: [1, 3, 7, 14],
    summaryDivider: {
      thicknessPx: 1,
      backgroundHex: '#404040',
    },
    defaultEnabled: false,
  },
  profile: {
    uiClassNames: {
      rootPadding: 'pt-[111px] px-4 pb-[124px]',
      rootGap: 'gap-2.5',
      rootSectionGap: 'gap-[25px]',
      avatarGroupGap: 'gap-[5px]',
      avatarNameGap: 'gap-[15px]',
      referralCardGap: 'gap-1.5',
      referralCardPadding: 'p-1.5',
      referralLinkButtonHeight: 'h-[52px]',
      referralLinkTextWidth: 'w-[287px]',
      surfaceRounded: 'rounded-[20px]',
      referralRowPadding: 'px-2 py-[7px]',
      avatarSize: 'h-[100px] w-[100px] rounded-[100px]',
      avatarContainerWidth: 'w-[143px]',
      referralPosition: 'absolute left-4 top-[265px]',
      primaryMenuPosition: 'absolute left-4 top-[403px]',
      secondaryMenuPosition: 'absolute left-4 top-[540px]',
      avatarPosition: 'absolute left-[125px] top-[73px]',
      menuDividerWidth: 'w-[345px]',
      menuRowLabelWidth: 'w-[270px]',
      avatarSkeletonSize: 'w-[100px] h-[100px]',
      pageRoot: 'flex min-h-screen min-w-screen flex-col items-center gap-2.5 overflow-hidden bg-[#000] px-5 pb-[90px] pt-[115px]',
      contentWrap: 'flex w-full max-w-[353px] flex-col items-center gap-[50px]',
      identitySection: 'flex w-fit flex-col items-center gap-5',
      avatarSizeCompact: 'h-[95px] w-[95px] rounded-[100px]',
      avatarImage: 'h-full w-full object-cover',
      avatarFallbackText: 'font-inter text-[32px] font-bold text-[#1C1C1E]',
      displayNameText: 'font-inter w-full text-center text-[19px] font-bold text-[#FFF]',
      menuSection: 'flex w-full flex-col items-start gap-[15px]',
      rowLeft: 'flex min-w-0 flex-1 items-center gap-2.5',
      iconSize: 'h-5 w-5',
      chevronIcon: 'h-3 w-[7px] overflow-hidden',
      singleRow: 'flex h-[49px] w-full items-center overflow-hidden rounded-[100px] bg-[#2C2C2E] px-[15px]',
      singleRowContent: 'flex w-full items-center justify-between',
      singleRowLabelWrap: 'flex min-w-0 flex-1 flex-col items-start',
      singleRowLabel: 'font-inter w-full text-left text-[17px] font-medium text-[#FFF]',
      groupCard: 'flex w-full flex-col items-center overflow-hidden rounded-[25px] bg-[#2C2C2E] pb-[5px] pl-[15px] pr-0 pt-[5px]',
      groupRow: 'flex w-full items-center justify-center gap-2.5 rounded-[20px] pb-2.5 pl-0 pr-[15px] pt-2.5',
      groupRowContent: 'flex w-full items-center justify-between',
      groupRowLabelWrap: 'flex min-w-0 flex-1 flex-col justify-center items-start',
      groupRowLabel: 'font-inter text-left text-base font-medium text-[#FFF]',
      groupDivider: 'h-px w-full bg-[#404040]',
      card: 'flex w-full flex-col items-end overflow-hidden rounded-[25px] bg-[#2C2C2E]',
      cardRow: 'flex w-full items-start gap-2.5 px-4 py-3.5 transition-opacity hover:opacity-90 active:opacity-80',
      cardRowContent: 'flex w-full items-center justify-between',
      cardRowLeft: 'flex w-fit items-center gap-2.5',
      iconWrap: 'flex h-7 w-7 items-center justify-center overflow-hidden rounded-[100px] p-[7px]',
      rowLabelText: 'font-poppins w-fit text-[17px] text-[#FFF]',
      cardDivider: 'h-px w-[345px] bg-[#404040]',
      loadingWrap: 'flex w-full items-center justify-center rounded-[25px] bg-[#2C2C2E] px-4 py-5',
      loadingText: 'font-poppins text-base text-[#ADADB4]',
    },
  },
  extend: {
    uiClassNames: {
      rootContainer: 'flex w-full flex-col items-center gap-2.5 overflow-hidden rounded-t-[40px] bg-[#1C1C1E] px-5 py-[30px]',
      closeRow: 'flex h-[38px] w-full items-center justify-end',
      contentContainer: 'flex w-full flex-col items-center gap-[30px]',
      headerContainer: 'flex w-full flex-col items-center gap-[15px]',
      iconSize: 'h-[100px] w-[100px] shrink-0',
      textContainer: 'flex w-full flex-col items-center gap-2.5',
      titleText: 'w-full text-center font-inter text-[21px] font-bold text-[#FFF]',
      descriptionText: 'w-full text-center font-inter text-sm font-medium text-[#ADADB4]',
      optionListContainer: 'flex w-full flex-col items-center gap-2.5',
      optionButton:
        'cursor-pointer text-nowrap flex h-12 w-full items-center justify-center gap-2.5 overflow-hidden rounded-[100px] bg-[#2C2C2E] px-[15px] py-0 transition-transform active:scale-[0.99] disabled:cursor-not-allowed disabled:opacity-60',
      optionText: 'w-fit font-inter text-[17px] font-medium text-[#0091FF]',
      unavailableText: 'w-full text-center font-inter text-sm font-medium text-[#ADADB4]',
    },
  },
  home: {
    uiClassNames: {
      arrowIconSize: 'w-[7px] h-3',
      arrowIconSquareSize: 'w-[7px] h-[7px]',
      guideCardPadding: 'py-2 px-2.5',
      guideCardRounded: 'rounded-[20px]',
      guideCardHeight: 'h-11',
      guideCardContentGap: 'gap-2.5',
      guideCardInnerGap: 'gap-3',
      skeletonShieldSize: 'w-[100px] h-[120px]',
      skeletonShieldRounded: 'rounded-[20px]',
      contentLiftOffset: '-mt-[35px]',
      successModalContent: 'p-8 pt-2 flex flex-col items-center',
      successModalIconWrap: 'mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-green-500/20',
      successModalTitle: 'mb-2 text-center text-xl font-bold',
      successModalDescription: 'mb-6 text-center text-sm',
    },
  },
  installGuide: {
    defaultDeviceId: 'appleTv',
    animation: {
      deviceSwitchDurationMs: 380,
      deviceSwitchEasing: 'cubic-bezier(0.42, 0, 0.58, 1)',
      deviceSwitchExitOpacity: 0.18,
      deviceSwitchEnterStartOpacity: 0.42,
      deviceSwitchTranslateYPx: 6,
      deviceSwitchScale: 0.997,
      deviceSwitchBlurPx: 0.8,
    },
    skeleton: {
      cardsCount: 3,
    },
    uiClassNames: {
      rootPadding: 'pt-[111px] px-4 pb-[29px]',
      contentWidth: 'w-[361px]',
      sectionGap: 'gap-[25px]',
      deviceHeaderWidth: 'w-[329px]',
      cardRounded: 'rounded-[25px]',
      cardPadding: 'py-3.5 px-4',
      cardGap: 'gap-2.5',
      pillButtonRounded: 'rounded-[100px]',
      pillButtonPadding: 'py-2 px-[25px]',
      stepIconWrap: 'w-9 overflow-hidden py-2.5 px-[5px] flex flex-col justify-center items-center gap-2.5',
      linkBoxRounded: 'rounded-[20px]',
      linkBoxPadding: 'p-3.5',
      subscriptionTextWidth: 'w-[300px]',
      titleTextSize: 'text-[22px]',
      subtitleTextSize: 'text-[17px]',
      stepTitleTextSize: 'text-[15px]',
      stepDescriptionTextSize: 'text-[17px]',
    },
  },
  navigation: {
    uiClassNames: {
      barBackground: 'bg-[#121212]',
      barBorderTop: 'border-t border-[#333333]',
      barPadding: 'px-6',
      barLayout: 'fixed bottom-0 left-0 right-0 flex py-0 justify-center items-center gap-10 w-full z-50',
      itemPadding: 'py-[15px] px-4',
      itemWidth: 'w-[79px]',
      itemGap: 'gap-2.5',
      itemLayout: 'flex flex-col items-center h-full overflow-hidden',
      itemInteraction: 'transition-all hover:opacity-80',
      itemIconBase: 'shrink-0 w-5 h-5 relative',
      navLabelTextSize: 'text-[13px]',
      navLabelBase: 'font-poppins font-semibold w-fit',
      profileDotPosition: 'absolute left-[7px] top-1',
    },
  },
  catalog: {
    uiClassNames: {
      contentGap: 'gap-20',
      sectionGap: 'gap-[25px]',
      headingGap: 'gap-2.5',
      listContainerGap: 'gap-[30px]',
      listTopPadding: 'pt-[34px]',
      packagesGap: 'gap-[15px]',
      packagesWidth: 'w-[363px]',
      packagePadding: 'py-5 px-0',
      packageRounded: 'rounded-[25px]',
      packageInnerWidth: 'w-[335px]',
      titleTextSize: 'text-[22px]',
      bodyTextSize: 'text-[17px]',
      tariffsLabelGap: 'gap-[178px]',
      popularBadgePosition: 'absolute left-[305px] -top-[3px]',
      skeletonPackageBg: 'bg-[#222]',
    },
  },
  referral: {
    primaryButtonBg: 'bg-[#00ABFF]',
    secondaryButtonBg: 'bg-[#163044]',
    secondaryButtonText: 'text-[#00ABFF]',
    uiClassNames: {
      contentTopPadding: 'pt-[10px]',
      iconContainerSize: 'w-24 h-24',
      statsGap: 'gap-[5px]',
      statsTextSize: 'text-[15px]',
      buttonsGap: 'gap-2.5',
    },
  },
} as const
